import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';
import { setupCountryCascade, setupCascade } from 'locations';
import { Settings } from 'settings.js.erb';

export default class extends Controller {
  connect() {
    _.each($(this.element).find('.country-select'), function(el){
      setupCountryCascade(el);
    });
    _.each($(this.element).find('.province-select'), function(el){
      setupCascade(el)
    });
  }

}
